import { FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxTextareaComponent } from './rx-textarea.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RxIconModule, RxTextareaComponent],
  exports: [RxTextareaComponent],
})
export class RxTextareaModule {}
